import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { REMOVE_SIGNATURE } from "../redux/actions/actionTypes";
import {
  UPDATE_MD_FORM,
  UPDATE_MD_FORM_ERROR,
} from "../redux/actions/formActions";
import { default as Button, default as CustomButton } from "./Button";
import RXForm from "./RXForm";
import SignatureComponent from "./Signature";
import SignatureModal from "./SignatureModal";
import { apiKey, serverBaseUrl } from "../config/envs";
import { useParams } from "react-router-dom";
import { showErrorToast } from "../utils/toast";

const FullComponent = ({ onModalClick, data, onClose, open, scrollToNext }) => {
  const { signSecretId } = useParams();
  const [currentDate, setCurrentDate] = useState();
  const dispatch = useDispatch();
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 640);
  const mdFormData = useSelector((state) => state?.form?.mdForm);
  const mdFormErrors = useSelector((state) => state?.form?.mdFormErrors);
  const signature = useSelector((state) => state?.signature);
  const { loading } = signature;
  const [isSignatureUploadLoading, setIsSignatureUploadLoading] =
    useState(false);

  const [formData, setFormData] = useState({
    presidentTitle: "",
    dateSigned: "",
    practiceName: "",
    signature: "",
    name: "",
    title: "",
    practiceNameforSignature: "",
    cardHolderDate: "",
    qualiphyPcName: "Qualiphy PC",
  });
  const [signType, setSignType] = useState("");
  const [signImages, setSignImages] = useState({
    adminPracticeSign: null,
    coveredEntitySign: null,
    practiceSign: null,
    cardHolderSignature: null,
    medicalDirectorSignature: null,
  });

  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    setCurrentDate(formattedDate);
  }, [currentDate]);

  const onSignatureSubmit = async (newImage, fillId) => {
    setSignImages((prevImages) => ({
      ...prevImages,
      [signType]: newImage,
    }));
    setFilledSignatureIds((prev) => [...prev, fillId]);
    await getAdminSignature();
    setIsSignatureUploadLoading(false);
    onClose();
    setSignType("");
  };

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [filledSignatureIds, setFilledSignatureIds] = useState([]);

  const handleChangeError = (key, value) => {
    dispatch({
      type: UPDATE_MD_FORM_ERROR,
      payload: { key, value },
    });
  };

  const [selectedFillId, setSelectedFillId] = useState("");

  const handleOnSignatureClick = useCallback(
    ({ type, fillId }) => {
      setSignType(type);
      setSelectedFillId(fillId);
      if (signImages[type] && !filledSignatureIds.includes(fillId)) {
        setFilledSignatureIds((prev) => [...prev, fillId]);
      } else {
        onModalClick();
      }
      handleChangeError(fillId, null);
    },
    [signImages, filledSignatureIds]
  );

  const handleOnSignatureChange = useCallback(
    ({ type, fillId }) => {
      setSignType(type);
      setSelectedFillId(fillId);
      onModalClick();
      setFilledSignatureIds([fillId]);
      handleChangeError(fillId, null);
    },
    [signImages, filledSignatureIds]
  );

  const [isMD, setIsMD] = useState(false);

  const uploadSignatureFile = useCallback(
    async (file, type, fillId) => {
      setIsSignatureUploadLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const uploadResponse = await axios.post(
          `${serverBaseUrl}/upload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "sign-secret-id": signSecretId,
            },
          }
        );
        if (uploadResponse.data?.data?.url) {
          if (signImages[type] != null) {
            const response = await axios.put(
              `${serverBaseUrl}/update_signature`,
              {
                signerId: isMD
                  ? data?.data?.signers[1]?.id
                  : data?.data?.signers[0]?.id,
                clinicId: data?.data?.qualiphy_clinic_id,
                url: uploadResponse.data?.data?.url,
                path: uploadResponse.data?.data?.url.split("/").pop(),
              },
              {
                headers: {
                  "sign-secret-id": signSecretId,
                },
              }
            );
            if (response?.data?.success) {
              onSignatureSubmit(uploadResponse.data?.data?.url, fillId);
            } else {
              showErrorToast(
                "Something went wrong while uploading signature, please try again"
              );
              setIsSignatureUploadLoading(false);
            }
            return;
          }
          const response = await axios.post(
            `${serverBaseUrl}/create_signature`,
            {
              signerId: isMD
                ? data?.data?.signers[1]?.id
                : data?.data?.signers[0]?.id,
              clinicId: data?.data?.qualiphy_clinic_id,
              url: uploadResponse.data?.data?.url,
              path: uploadResponse.data?.data?.url.split("/").pop(),
            },
            {
              headers: {
                "sign-secret-id": signSecretId,
              },
            }
          );
          if (response?.data?.success) {
            onSignatureSubmit(uploadResponse.data?.data?.url, fillId);
          } else {
            showErrorToast(
              "Something went wrong while uploading signature, please try again"
            );
            setIsSignatureUploadLoading(false);
          }
        }
      } catch (err) {
        console.error("Upload signature error:", err);
        setIsSignatureUploadLoading(false);
      }
    },
    [data, isMD, signImages]
  );

  const removeSignature = async (file) => {
    let _payLoad = {
      signerId: data.data?.signers[0]?.id,
      clinicId: data?.data?.qualiphy_clinic_id,
      signSecretId: signSecretId,
    };
    dispatch({
      type: REMOVE_SIGNATURE,
      payload: _payLoad,
    });
  };

  const handleChangeMDForm = (e) => {
    dispatch({
      type: UPDATE_MD_FORM,
      payload: { key: e.target.name, value: e.target.value },
    });
  };

  useEffect(() => {
    if (data?.data?.status === 1) {
      setIsMD(true);
    } else {
      setIsMD(false);
    }
  }, [data]);

  useEffect(() => {
    if (signSecretId && data?.data) {
      getAdminSignature();
    }
  }, [signSecretId, data]);

  const getAdminSignature = useCallback(async () => {
    if (data?.data?.signers[0]?.id) {
      try {
        const response = await axios.get(
          `${serverBaseUrl}/get_signature?signerId=${data?.data?.signers[0]?.id}`,
          {
            headers: {
              "sign-secret-id": signSecretId,
            },
          }
        );

        if (response?.data?.data[0]?.url) {
          setSignImages((prevImages) => ({
            ...prevImages,
            adminPracticeSign: response?.data?.data[0]?.url,
          }));

          if (data?.data?.status === 1) {
            setFilledSignatureIds((prev) => [
              ...prev,
              "signature_1",
              "signature_2",
              "signature_3",
            ]);
          }
        } else {
          setSignImages((prevImages) => ({
            ...prevImages,
            adminPracticeSign: null,
          }));
        }
      } catch (error) {
        console.error("Fetch signature error:", error);
        setSignImages((prevImages) => ({
          ...prevImages,
          adminPracticeSign: null,
        }));
      }
    }
    if (data?.data?.signers[1]?.id) {
      try {
        const response = await axios.get(
          `${serverBaseUrl}/get_signature?signerId=${data?.data?.signers[1]?.id}`,
          {
            headers: {
              "sign-secret-id": signSecretId,
            },
          }
        );

        if (response?.data?.data[0]?.url) {
          setSignImages((prevImages) => ({
            ...prevImages,
            medicalDirectorSignature: response?.data?.data[0]?.url,
          }));
        } else {
          setSignImages((prevImages) => ({
            ...prevImages,
            medicalDirectorSignature: null,
          }));
        }
      } catch (error) {
        console.error("Fetch signature error:", error);
        setSignImages((prevImages) => ({
          ...prevImages,
          medicalDirectorSignature: null,
        }));
      }
    }
  }, [data, signSecretId]);

  return (
    <div className="mt-10 max-w-4xl w-full space-y-6 bg-white border overflow-hidden rounded-xl shadow-lg flex flex-col border-1 border-gray-900">
      <div className="z-50 mt-3 hidden md:hidden lg:block fixed top-25   -ml-20">
        {data?.data?.consent && isLargeScreen && (
          <div className="z-50 mt-3 hidden md:hidden lg:block fixed top-25">
            <Button
              backgroundColor="rgb(207 201 255)"
              labelColor="black"
              className="h-10 border-0 border-white-600"
              label="Fill In"
              onClick={scrollToNext}
              top={3}
            />
          </div>
        )}
      </div>

      <div className="bg-white text-gray-900 space-y-4 px-6">
        <p className="mt-0 ml-[0.15pt] mb-3 -indent-[0.15pt] text-center leading-normal text-[14pt] align-top font-[Times New Roman] font-bold uppercase">
          qualiphy medical services agreement
        </p>
        <p className="mt-0 ml-[0.1pt] mb-3 -indent-[0.1pt] text-justify leading-normal align-top">
          <a id="_heading_h.gjdgxs"></a>
          <span className="font-[Times New Roman] align-top">
            This Professional Services Agreement (this “
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">Agreement</span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            ”), effective as of the date the Agreement is signed by both parties
            (the “
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">
              Effective Date
            </span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            ”), is by and between Qualiphy PC, a California professional medical
            corporation, with offices located at 113 N. San Vicente Boulevard
            3rd Floor, Beverly Hills, CA 90211 (“
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">Qualiphy</span>
          </strong>
          <span className="font-[Times New Roman] align-top">”) and</span>
          <input
            type="text"
            id="name_of_practice_0"
            placeholder="Pratices Name"
            name="name_of_practice"
            value={mdFormData?.name_of_practice}
            onChange={(e) => handleChangeMDForm(e)}
            disabled={isMD}
            className="border border-gray-300 rounded py-1 px-2 w-1/3"
          />
          <span className="font-[Times New Roman] align-top">(“</span>
          <strong>
            <span className="font-[Times New Roman] align-top">Practice</span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            ”). Qualiphy and Practice are each referred to herein individually
            as a “
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">Party</span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            ” and collectively as the “
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">Parties</span>
          </strong>
          <span className="font-[Times New Roman] align-top">”.</span>
        </p>

        <p className="mt-0 ml-[0.1pt] mb-3 -indent-[0.1pt] text-center leading-normal align-top">
          <strong>
            <span className="font-[Times New Roman] align-top">BACKGROUND</span>
          </strong>
          <a id="bookmark_id.30j0zll"></a>
        </p>

        <p className="mt-0 ml-[0.1pt] mb-3 -indent-[0.1pt] text-justify leading-normal align-top">
          <span className="font-[Times New Roman] align-top">&nbsp;</span>
          <strong>
            <span className="font-[Times New Roman] align-top">WHEREAS</span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            , Practice is a legally formed and qualified professional entity
            rendering medical services through its licensed providers who are
            duly licensed to practice medicine and/or nursing in the state(s) in
            which Practice or Scope of Practice and its patients are located
            (the “
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">
              Practice State(s)
            </span>
          </strong>
          <span className="font-[Times New Roman] align-top">”)</span>
        </p>

        <p className="mt-0 ml-[0.1pt] mb-3 -indent-[0.1pt] text-justify leading-normal align-top">
          <span className="font-[Times New Roman] align-top">&nbsp;</span>
          <strong>
            <span className="font-[Times New Roman] align-top">WHEREAS</span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            , Qualiphy providers are also licensed in the Practice State(s), to
            render medical services, including urgent care, weight loss, hair
            loss, erectile dysfunction treatment(s), and if necessary, issue
            prescriptions through its medical providers;
          </span>
        </p>

        <p className="mt-0 ml-[0.1pt] mb-3 -indent-[0.1pt] text-justify leading-normal align-top">
          <span className="font-[Times New Roman] align-top">&nbsp;</span>
          <strong>
            <span className="font-[Times New Roman] align-top">WHEREAS</span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            , Practice desires to engage Qualiphy PC for the limited purpose of
            reviewing relevant patient history, conducting patient examinations
            via telemedicine and if necessary, issuing an applicable diagnosis
            (“
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">
              Patient Evaluation
            </span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            ”), as well as writing prescriptions pursuant to such diagnosis (the
            “
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">Treatment</span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            ”) and collectively (the “
          </span>
          <strong>
            <span className="font-[Times New Roman] align-top">
              Professional Services
            </span>
          </strong>
          <span className="font-[Times New Roman] align-top">”);</span>
        </p>

        <p className="mt-0 ml-[0.1pt] mb-3 -indent-[0.1pt] text-justify leading-normal align-top">
          <span className="font-[Times New Roman] align-top">&nbsp;</span>
          <strong>
            <span className="font-[Times New Roman] align-top">WHEREAS</span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            , Practice desires to initiate the transfer of patient care to
            Qualiphy for the sole purpose of performing the Professional
            Services, and once discharged by Qualiphy, immediately resume
            responsibility for the medical supervision and continuity of care
            for said patients;
          </span>
        </p>

        <p className="mt-0 ml-[0.1pt] mb-3 -indent-[0.1pt] text-justify leading-normal align-top">
          <span className="font-[Times New Roman] align-top">&nbsp;</span>
          <span className="font-[Times New Roman] align-top">&nbsp;</span>
          <strong>
            <span className="font-[Times New Roman] align-top">
              NOW THEREFORE
            </span>
          </strong>
          <span className="font-[Times New Roman] align-top">
            , for good and valuable consideration, the receipt and adequacy of
            which is hereby acknowledged, including the mutual covenants
            contained herein, the Parties desire to enter into this Agreement to
            set forth terms and conditions related to Qualiphy’s relationship
            with the Practice as an independent contractor.
          </span>
        </p>

        <p className="mt-0 ml-[0.1pt] mb-3 -indent-[0.1pt] text-center leading-normal align-top">
          <strong>
            <span className="font-[Times New Roman] align-top">AGREEMENT</span>
          </strong>
        </p>

        <ol
          className="awlist1 text-justify"
          style={{ margin: "0pt", paddingLeft: "0pt" }}
        >
          <li className="main-list-item">
            <strong>
              <u>Qualiphy’s Professional Services</u>
            </strong>
            .
            <ol className="nested-list">
              <li>
                Practice engages Qualiphy to provide Professional Services
                through its licensed medical providers, consistent with the
                requirements of state and federal law. Qualiphy will perform the
                Professional Services in a competent and professional manner.
                Qualiphy will not be required to perform services that violate
                the law or, in Qualiphy’s sole discretion, any other ethical
                considerations, or that are inconsistent with the Parties’
                rights and obligations under this Agreement.
              </li>
              <li>
                Qualiphy providers will be appropriately licensed and supervised
                in the Practice State(s) and will meet the standard of care
                applicable to the Professional Services being provided.
              </li>
              <li>
                All Professional Services will be provided via telemedicine, as
                defined by the Practice State(s). Qualiphy providers will
                establish a valid patient-provider relationship via telemedicine
                pursuant to all applicable local, state, and federal laws,
                regulations, and professional standards with the patient.
                Qualiphy providers will be located in a private HIPAA-compliant
                environment. Qualiphy’s Professional Services will include:
                <ol>
                  <li>
                    Obtaining patient medical history and performing patient
                    examination via telemedicine adequate to establish the
                    diagnosis and treatment, where applicable.
                  </li>
                  <li>
                    Having sufficient dialogue with the patient regarding
                    treatment options and the risks and benefits of said
                    treatments.
                  </li>
                  <li>
                    Determining if additional treatment is necessary, and if so,
                    facilitating the prescription of the treatment.
                  </li>
                </ol>
              </li>
              <li>
                Practice shall assist, as needed, in determining whether
                Qualiphy’s screening questions and criteria are sufficient.
              </li>
            </ol>
          </li>

          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "27.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <u>
                <span style={{ verticalAlign: "top" }}>
                  Practice’s Obligations
                </span>
              </u>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              . As consideration to Qualiphy for the Professional Services, and
              in addition to the payment terms set forth herein and on Exhibit
              A, throughout the Term of this Agreement, Practice agrees as
              follows:
            </span>
          </li>
        </ol>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.1
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Practice confirms that Practice has a licensed physician medical
            director responsible for the initial transfer of patients to
            Qualiphy, as well as the return of said patients to the Practice for
            continuing care and treatment upon discharge from Qualiphy’s care.
            Practice shall maintain responsibility for all aspects of the
            patient transfer process, including issuance of relevant patient
            notifications to such effect.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.2
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Practice will keep and maintain appropriate and accurate records,
            reports, claims, and correspondence in connection with all services
            rendered by Practice for all patients for which Qualiphy has
            provided Professional Services consistent with applicable state and
            federal law.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.3
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Practice represents and warrants that the Medical Director has
            written, reviewed, and approved for the transfer of patients to
            Qualiphy and return to Practice upon discharge following the
            outlines below.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.4{" "}
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Transition of Care: Upon discharge of a patient from Qualiphy’s
            care, the Practice will assume full responsibility for the patient’s
            ongoing care. The Practice shall promptly review and respond to the
            treatment notes and handoff summary provided by Qualiphy via PDF in
            Qualiphy Portal. The Practice must ensure continuity of care by
            scheduling follow-up visits, addressing patient concerns, and
            managing prescribed medications. In compliance with applicable state
            and federal laws, Qualiphy providers may engage in direct follow-up
            with patients in cases where it is legally mandated or deemed
            medically necessary.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.5{" "}
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Patient Communication Post-Discharge: The Practice shall be the sole
            and primary point of contact for all patient inquiries, follow-up
            care, and questions related to the patient’s treatment or
            prescriptions. The Practice must provide patients with a direct
            contact number and email for follow-up care at the time of
            discharge. Qualiphy providers shall not serve as the primary contact
            for patients post-discharge, except where legally mandated or in
            case of emergency backstop measures (as detailed in Section{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.6
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            The Practice agrees to provide patients with clear, accessible
            resources to address questions or concerns about their treatment,
            including a dedicated phone line and email for patient inquiries.
            The Practice shall also ensure that patients are informed of this
            support structure during follow-up communication.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.7{" "}
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Notification to Patients: The Practice must notify patients of their
            responsibility to contact the Practice directly for all follow-up
            care. Qualiphy will assist by sending initial post-discharge
            instructions to the patient, including the Practice’s contact
            information, and indicating that all future inquiries must be
            directed to the Practice. Patients will also be informed that
            Qualiphy providers are no longer responsible for ongoing care unless
            otherwise indicated.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.8{" "}
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Acknowledgment of Responsibility: By entering this Agreement, the
            Practice acknowledges that it is the primary entity responsible for
            patient care after discharge, including addressing questions,
            providing follow-ups, and resolving treatment-related concerns. The
            Practice agrees to indemnify Qualiphy for any claims arising from
            delays or gaps in ongoing care post-discharge.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.9
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            All patient medication and treatment instructions, continued
            medication management, patient care, patient questions, and any
            other patient needs once the patient is discharged from Qualiphy
            shall be the sole responsibility of Practice.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.10
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Practice will share and maintain appropriate and accurate records,
            reports, claims, and correspondence with Qualiphy prior to its
            rendering of the Professional Services.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.11 Exceptions for Direct Qualiphy Contact:
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Notwithstanding the above, Qualiphy reserves the right to contact
            patients directly to address: Adverse drug reactions or medical
            emergencies requiring immediate attention. Clarifications of
            prescriptions or treatment plans, as legally required. Backstop
            measures where the Practice has failed to respond within 24 hours to
            a patient inquiry, subject to additional charges outlined in Exhibit
            A.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.12{" "}
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Practice acknowledges that Qualiphy has the right to communicate
            directly with patients after their treatment to provide instructions
            on how to administer the treatment and to offer guidance on what to
            do if further assistance is needed. Qualiphy will send these
            instructions to the patient via email and will include the contact
            information of the person at the Practice who is responsible for the
            patient’s ongoing clinical care. Practice agrees to provide Qualiphy
            with the correct contact information for the person responsible for
            the patient's care. If Practice does not provide this information,
            Practice consents to Qualiphy sending the contact information of the
            individual(s) who signed up to use Qualiphy as the default point of
            contact for patient inquiries. Additionally, Qualiphy may include an
            aftercare link in the communication sent to the patient. This link
            will contain language indicating that if the patient has attempted
            to reach all provided points of contact at the Practice without
            success, Qualiphy will offer a backup option. The patient can click
            on this backup link to connect with a Qualiphy provider
            synchronously. The charge to the Practice for this encounter
            outlined in Exhibit A and in the the Qualiphy Portal. The summary of
            the reason for the visit will be available in the Qualiphy Portal.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.13
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Practice must maintain adequate professional liability insurance as
            required by applicable law on behalf of each of its providers and
            must continue to do so throughout the Term of this Agreement. Such
            insurance must have limits no less than one million dollars
            ($1,000,000.00) per claim and no less than three million dollars
            ($3,000,000.00) in the aggregate for any policy year and be the
            primary liability insurance related to Practice’s providers. Upon
            Qualiphy’s request, Practice will provide proof of such insurance.
          </span>
        </p>
        <p
          style={{
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            pageBreakAfter: "avoid",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                2.14 Practice’s Obligations with Respect to Practice’s Medical
                Director.
              </span>
            </u>
          </strong>
        </p>
        <ol className="awlist3" style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              pageBreakAfter: "avoid",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.78pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice confirms that the Practice’s medical director (the “
            </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>Medical Director</span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              ”) has the required education, training, and expertise as it
              relates to medical services provided by the Practice.
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice must inform Qualiphy of any change to Practice’s Medical
              Director within five business days of such change.
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.78pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              In the event of any change to Practice’s Medical Director,
              Practice must provide Qualiphy with all relevant information
              related to the newly appointed Medical Director, including but not
              limited to, name, address, dates of transition and medical
              director licensure status.
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              In the event Practice does not timely replace a departed Medical
              Director, Qualiphy reserves the right to immediately cease
              Professional Services until a new qualified medical director is
              appointed.
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.78pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice confirms Medical Director is in good standing and
              licensed in the states in which Practice uses Qualiphy services.{" "}
            </span>
          </li>
          <li
            style={{
              margin: "0pt 7.2pt 12pt 0.1pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              widows: 0,
              orphans: 0,
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "24.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice further agrees that any “custom” exam(s) created within
              the Qualiphy portal, have been written, reviewed and approved by
              the Medical Director.{" "}
            </span>
          </li>
          <li
            style={{
              margin: "0pt 7.2pt 12pt 0.1pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              widows: 0,
              orphans: 0,
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice agrees to receive SMS message(s) from Qualiphy and has
              written consent from patients to receive text message(s), calls
              and emails from Qualiphy as it relates to medical screening.{" "}
            </span>
            <a id="bookmark_id.3znysh7" />
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginRight: "7.2pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "96%",
              widows: 0,
              orphans: 0,
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice must provide Practice’s Medical Director with a copy of
              this Agreement.
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginRight: "7.2pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "96%",
              widows: 0,
              orphans: 0,
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "24.77pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice may opt out of Qualiphy emailing the patient with
              information on treatment, injection and instructions. In the event
              practice opts out of such correspondence between Qualiphy and
              Patient, Practice will follow up, provide access to patients with
              a phone number, chat, text or other means of communicating with
              patient for care, questions and treatment.
            </span>
          </li>
        </ol>
        <p
          style={{
            marginTop: "0pt",
            marginRight: "7.2pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "96%",
            widows: 0,
            orphans: 0,
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <ol
          start={3}
          className="awlist4"
          style={{ margin: "0pt", paddingLeft: "0pt" }}
        >
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "27.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <u>
                <span style={{ verticalAlign: "top" }}>Payment Terms</span>
              </u>
            </strong>
            <a id="bookmark_id.2et92p0" />
            <strong>
              <u>
                <span style={{ verticalAlign: "top" }}>. </span>
              </u>
            </strong>
            <strong>
              <span style={{ verticalAlign: "top" }}>
                Pricing and Payment Terms.
              </span>
            </strong>
            <ol
              className="awlist2"
              style={{
                marginRight: "0pt",
                marginLeft: "0pt",
                paddingLeft: "0pt",
              }}
            >
              <li
                style={{
                  marginTop: "12pt",
                  marginBottom: "12pt",
                  lineHeight: "12pt",
                  verticalAlign: "-0.5pt",
                }}
              >
                <span
                  style={{
                    width: "21.1pt",
                    font: '7pt "Times New Roman"',
                    display: "inline-block",
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                <span style={{ verticalAlign: "top" }}>
                  Qualiphy shall clearly publish the pricing for each
                  Professional Service in advance and next to each type of exam,
                  treatment, or service. The pricing will reflect the expertise
                  required, the level of care, and any associated medication
                  costs. Upon initiating any patient transfer to Qualiphy, the
                  Practice agrees to the price displayed for that specific
                  service. Qualiphy reserves the right to update or change the
                  pricing for its services at any time, with such changes
                  reflected in the pricing prior to the initiation of any new
                  patient transfer.
                </span>
              </li>
              <li
                style={{
                  marginTop: "12pt",
                  marginBottom: "12pt",
                  lineHeight: "12pt",
                  verticalAlign: "-0.5pt",
                }}
              >
                <span
                  style={{
                    width: "21.1pt",
                    font: '7pt "Times New Roman"',
                    display: "inline-block",
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                <span style={{ verticalAlign: "top" }}>
                  If the Practice requests follow-up appointments or additional
                  examinations after the patient's discharge, Qualiphy may
                  assess additional fees, which will be clearly communicated and
                  charged accordingly.
                </span>
              </li>
              <li
                style={{
                  marginTop: "12pt",
                  marginBottom: "12pt",
                  lineHeight: "12pt",
                  verticalAlign: "-0.5pt",
                }}
              >
                <span
                  style={{
                    width: "21.1pt",
                    font: '7pt "Times New Roman"',
                    display: "inline-block",
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                <span style={{ verticalAlign: "top" }}>
                  The Practice agrees to maintain a valid credit card on file,
                  as detailed in the Credit Card Authorization (Exhibit A).
                  Credit cards will be charged for all payments due under this
                  Agreement. If there is a change to the credit card
                  information, the Practice must promptly notify Qualiphy and
                  provide updated information.
                </span>
              </li>
              <li
                style={{
                  marginTop: "12pt",
                  marginBottom: "12pt",
                  lineHeight: "12pt",
                  verticalAlign: "-0.5pt",
                }}
              >
                <span
                  style={{
                    width: "21.1pt",
                    font: '7pt "Times New Roman"',
                    display: "inline-block",
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                <span style={{ verticalAlign: "top" }}>
                  In the event of a declined or failed payment, Qualiphy will
                  immediately notify the Practice, which will then have three
                  days to resolve the payment issue. During this time, no
                  further services will be provided until payment is made.
                  Qualiphy will automatically lock the Practice out of its
                  services. The Practice must then re-enter valid credit card
                  information and settle any outstanding payments, including
                  interest accrued at a rate of 5% per month on overdue amounts,
                  before regaining access to Qualiphy's services.
                </span>
              </li>
              <li
                style={{
                  marginTop: "12pt",
                  marginBottom: "12pt",
                  lineHeight: "12pt",
                  verticalAlign: "-0.5pt",
                }}
              >
                <span
                  style={{
                    width: "21.1pt",
                    font: '7pt "Times New Roman"',
                    display: "inline-block",
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                <span style={{ verticalAlign: "top" }}>
                  Qualiphy will not directly bill any patient nor accept any
                  payment from patients. All Qualiphy providers offering
                  services to the Practice will be compensated by Qualiphy.
                </span>
              </li>
              <li
                style={{
                  marginTop: "0pt",
                  marginBottom: "12pt",
                  verticalAlign: "-0.5pt",
                }}
              >
                <span
                  style={{
                    width: "21.1pt",
                    font: '7pt "Times New Roman"',
                    display: "inline-block",
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                <span style={{ verticalAlign: "top" }}>
                  Qualiphy shall publish pricing to Practice for rendering the
                  Professional Services in advance of Practice initiating a
                  transfer of a patient. Upon initiating a transfer of any
                  patient to Qualiphy for rendering of the Professional Services
                  described herein, Practice agrees to the price published to
                  the Practice.
                </span>
                <span style={{ verticalAlign: "top" }}>&nbsp; </span>
                <span style={{ verticalAlign: "top" }}>
                  Qualiphy, in its sole and absolute discretion, reserves the
                  right to update and/or change the pricing of its Professional
                  Services at any time.{" "}
                </span>
              </li>
            </ol>
          </li>
        </ol>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            4.{" "}
          </span>
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                Term and Termination.
              </span>
            </u>
          </strong>
          <a id="bookmark_id.tyjcwt" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            4.1{" "}
          </span>
          <span
            style={{
              width: "18.1pt",
              textIndent: "0pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "top",
              display: "inline-block",
            }}
          >
            &nbsp;
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            This Agreement will commence on the Effective Date and will continue
            in effect until terminated by either Qualiphy or Practice as set
            forth in this Section 4. The time period during which the Agreement
            is in effect is referred to herein as the “
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Term
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                4.2{" "}
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  width: "18.1pt",
                  textIndent: "0pt",
                  fontFamily: '"Lucida Console"',
                  fontSize: "10pt",
                  display: "inline-block",
                }}
              >
                &nbsp;&nbsp;
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                Termination by Mutual Agreement.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            This Agreement will terminate immediately upon the mutual written
            agreement of the Parties.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                4.3{" "}
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  width: "18.1pt",
                  textIndent: "0pt",
                  fontFamily: '"Lucida Console"',
                  fontSize: "10pt",
                  display: "inline-block",
                }}
              >
                &nbsp;&nbsp;
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                Termination Without Cause.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Either party, in its sole discretion, may terminate this Agreement
            at any time and for any reason by providing at least 30 days’ prior
            written notice to the other Party.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            All fees must be paid through the termination date.{" "}
          </span>
          <a id="bookmark_id.1t3h5sf" />
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Qualiphy reserves the right discontinue services for a practice and
            the right to use Qualiphy services for any reason, immediately.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                4.4{" "}
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  width: "18.1pt",
                  textIndent: "0pt",
                  fontFamily: '"Lucida Console"',
                  fontSize: "10pt",
                  display: "inline-block",
                }}
              >
                &nbsp;&nbsp;
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                Termination by Qualiphy.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            This Agreement may be immediately terminated by Qualiphy by written
            notice to the Practice, upon the occurrence of any of the following:
          </span>
        </p>
        <ol className="awlist3" style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.78pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice does not have a Medical Director;
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice or any of its owners or employees are investigated,
              charged, sanctioned, or closed by any federal or the Practice
              State(s) in which Practice operates agency with jurisdiction over
              the Practice, or by any medical or other government regulatory
              board;
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.78pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice or any of the owners of Practice are convicted in a
              criminal or civil proceeding of fraud, misappropriation,
              embezzlement, or the commission of a felony or of a
              narcotic-related offense or pleads nolo contendere to any such
              charge;
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice disputes any valid charges to Practice’s credit card on
              file;
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.78pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice breaches any material obligation or covenant under this
              Agreement, breaches any representation or warranty made by
              Practice, or fails to faithfully perform the services required by
              this Agreement; provided Practice is first given written notice of
              default and ten business days to cure the alleged breach if able
              to be cured; or
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "24.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              The liquidation or dissolution of Practice, the filing of a
              petition in bankruptcy with respect to the Practice or the
              Practice’s owners, the Practice’s or its owners’ application for
              or, consent to the appointment of a trustee, receiver or custodian
              for the Practice or its owners or a substantial part of its/their
              assets, or the entry of any order therefore, or the Practice’s or
              its owners’ making of any general assignment for the benefit of
              its creditors.
            </span>
          </li>
        </ol>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                5. Termination by Practice
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            . Practice may immediately terminate this Agreement by written
            notice to Qualiphy, upon the occurrence of any of the following:
          </span>
        </p>
        <ol
          start={7}
          className="awlist5"
          style={{ margin: "0pt", paddingLeft: "0pt" }}
        >
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Qualiphy provides an unlicensed provider to provide Professional
              Screening Services to Practice;
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Qualiphy breaches any material obligation or covenant under this
              Agreement, or Qualiphy fails to faithfully perform the services
              required by this Agreement; provided Qualiphy is first given
              written notice of default and ten business days to cure the
              alleged breach if able to be cured;
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "24.77pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              The filing of a petition in bankruptcy with respect to Qualiphy,
              Qualiphy’s application for or, consent to the appointment of a
              trustee, receiver or custodian for Qualiphy or a substantial part
              of Qualiphy’s assets, or the entry of any order therefore, or
              Qualiphy’s making of any general assignment for the benefit of its
              creditors; or
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "24.77pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              The dissolution of Qualiphy
            </span>
            <a id="bookmark_id.4d34og8" />
            <span style={{ verticalAlign: "top" }}>.</span>
          </li>
        </ol>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                6. Effects of Termination or Expiration
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            . Upon termination of this Agreement, the Parties will not have any
            further rights, duties, or obligations under this Agreement, except
            as otherwise provided herein. The termination or expiration will not
            affect any liability or other obligation of the Parties that accrued
            prior to the termination or expiration. Any compensation owed to
            Qualiphy for Professional Screening Services provided by Qualiphy
            prior to the date of termination will remain payable to Qualiphy and
            will be charged to Practice’s credit card on file.
          </span>
          <a id="bookmark_id.2s8eyo1" />
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                7.
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  width: "27.1pt",
                  textIndent: "0pt",
                  fontFamily: '"Lucida Console"',
                  fontSize: "10pt",
                  display: "inline-block",
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                Business Associate Addendum
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            . Qualiphy and Practice agree to comply with all state and federal
            patient privacy and data laws, including but not limited the Health
            Insurance Portability and Accountability Act of 1996 and all rules,
            regulations, and related laws and acts promulgated under and in
            connection with such Act (collectively, “
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              HIPAA
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”). The Parties therefore desire to enter into a Business Associate
            Addendum regarding the use and/or disclosure of Protected Health
            Information as required by HIPAA, as may be amended from time to
            time, which is attached hereto as Exhibit B and incorporated by
            reference.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                8.{" "}
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  width: "24.1pt",
                  textIndent: "0pt",
                  fontFamily: '"Lucida Console"',
                  fontSize: "10pt",
                  display: "inline-block",
                }}
              >
                &nbsp;&nbsp;&nbsp;
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                Notification of State or Federal Action or a Complaint
              </span>
            </u>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              .
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Qualiphy will notify Practice as soon as possible and within a
            reasonable time period, if any provider provided by Qualiphy to the
            Practice is disciplined concerning an allegation of professional
            misconduct, or if any provider provided by Qualiphy to the Practice
            otherwise loses a license to practice, or if any person files any
            type of complaint against any provider provided by Qualiphy to the
            Practice, whether in court or to a state body. Practice will
            immediately notify Qualiphy, in writing, if Practice or any of its
            employees or owners is investigated, indicted, or disciplined
            concerning violation of any state or federal applicable law,
            professional misconduct, or if any of the licensed personnel of
            Practice will fall out of good standing or have their licenses
            disciplined or revoked, or if there is a malpractice suit filed
            against the Practice or any of the Practice’s providers related to
            any patients for whom Qualiphy provided Professional Screening
            Services.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                9.{" "}
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  width: "24.1pt",
                  textIndent: "0pt",
                  fontFamily: '"Lucida Console"',
                  fontSize: "10pt",
                  display: "inline-block",
                }}
              >
                &nbsp;&nbsp;&nbsp;
              </span>
            </u>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                Inde
              </span>
            </u>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              p
            </span>
          </strong>
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                endent Contractor Status.
              </span>
            </u>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              {" "}
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The Parties acknowledge and agree that the Parties are at all times
            independent contractors under this Agreement. Nothing in this
            Agreement will in any way be construed to constitute Qualiphy as an
            agent, employee, or representative of Practice. The sole function of
            Qualiphy, under this Agreement, is to provide Professional Services
            through its employees and contractors. Qualiphy will not, by
            entering into this Agreement and performing the Professional
            Services, become liable for any of the obligations or liabilities of
            Practice as it relates to practice of medicine and provision of
            professional services to patients by the Practice or any employee,
            agent, representative or independent contractor of Practice.
            Qualiphy will not have any liability whatsoever for damages suffered
            on account of the provision of services to patients by any employee,
            agent, representative or independent contractor of Practice. The
            terms of this Section 9 will survive this Agreement indefinitely.
          </span>
          <a id="bookmark_id.17dp8vu" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                10. Representations and Warranties of Practice and Medical
                Director
              </span>
            </u>
          </strong>
          <u>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              .
            </span>
          </u>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            10.1 Practice represents and warrants to Qualiphy at all times
            during the Term of this Agreement that:
          </span>
        </p>
        <ol
          start={11}
          className="awlist6"
          style={{ margin: "0pt", paddingLeft: "0pt" }}
        >
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice will at all times have a Medical Director, and the
              Medical Director will approve all screening questionnaires used by
              Qualiphy;
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "24.77pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice will employ licensed providers who have the appropriate
              license, training and experience;
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "18.77pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice will ensure that all providers providing treatments are
              at all times appropriately supervised as required by applicable
              state law.
            </span>
            <span style={{ verticalAlign: "top" }}>&nbsp; </span>
            <span style={{ verticalAlign: "top" }}>
              Practice’s Medical Director will provide or ensure there is
              another appropriately licensed physician available to provide
              direct supervision for any treatments provided by Practice
              requiring supervision and overview by a physician as required by
              state law;
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice and Medical Director will at all times comply with HIPAA
              and any applicable state privacy laws;
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice will maintain all necessary permits, filings and
              registrations with the appropriate government boards and bodies in
              the state(s) of its location and with the federal government;
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice and its owners and/or employees, as applicable, have
              obtained and will maintain all proper licenses, certifications,
              and permits required for operation as a medical practice in the
              state, county and city in which the Practice is located;
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice is in compliance with all state laws, rules and
              regulations relating to the practice of medicine, including any
              corporate practice of medicine laws, rules and regulations
              relating to its business, operations and corporate structure as
              applicable;
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "24.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice is in compliance with and will continue to be in
              compliance with and obey all federal, state, and local laws,
              regulations and ordinances relating to its business and the
              professional services which Practice provides; and
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "23.44pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Practice and Medical Director will maintain proper policy and
              procedures for treatment of patients, including a plan for
              emergency response to evaluate and treat based on specific patient
              circumstance in consultation with Medical Director.
            </span>
          </li>
        </ol>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                11. Qualiphy Representations and Warranties.
              </span>
            </u>
          </strong>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            11.1 Qualiphy represents and warrants to Practice at all times
            during the Term of this Agreement that:
          </span>
        </p>
        <ol
          start={20}
          className="awlist7"
          style={{ margin: "0pt", paddingLeft: "0pt" }}
        >
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "24.77pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Qualiphy and its employees will at all times comply with HIPAA;
              and
            </span>
          </li>
          <li
            style={{
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              textAlign: "justify",
              lineHeight: "normal",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
            }}
          >
            <span
              style={{
                width: "22.11pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}>
              Each Qualiphy provider providing Professional Services for
              Practice will be actively licensed to practice with the Practice
              State(s) during the time such provider is providing the
              Professional Screening Services for Practice and will provide such
              services within the scope of their license.{" "}
            </span>
            <a id="bookmark_id.3rdcrjn" />
          </li>
        </ol>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            11.2 EXCEPT FOR THE EXPRESS WARRANTIES IN THIS AGREEMENT, QUALIPHY
            HEREBY DISCLAIMS ALL WARRANTIES, EITHER EXPRESS, IMPLIED, STATUTORY,
            OR OTHERWISE. QUALIPHY MAKES NO GUARANTEES OR WARRANTIES EXPRESS OR
            IMPLIED REGARDING SUCCESS OF ANY TREATMENT PROVIDED.
          </span>
          <a id="bookmark_id.26in1rg" />
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            ALL PATIENT CARE AND MANAGEMENT IS THE FULL RESPONSIBILITY OF
            PRACTICE.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                12. Indemnification.
              </span>
            </u>
          </strong>
          <a id="bookmark_id.lnxbz9" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            12.1 Practice agrees to promptly and fully defend, indemnify and
            hold harmless Qualiphy and its owners, affiliates, providers,
            officers, directors, members, attorneys employees and agents against
            all third party claims, liabilities, demands, judgments, damages,
            losses, costs and expenses, including reasonable attorney’s fees,
            arising out of or relating to: (a) the acts or omissions of
            Practice, its owners, medical directors, employees and agents; or
            (b) Practice’s breach of any representation or warranty in this
            Agreement.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                LIMITATION OF LIABILITY.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            THE PRACTICE ACKNOWLEDGES AND AGREES THAT THE LIMITATIONS OF
            LIABILITY SET FORTH IN THIS AGREEMENT ARE REASONABLE AND REFLECT A
            FAIR ALLOCATION OF RISK BETWEEN THE PARTIES. THE PRACTICE FURTHER
            ACKNOWLEDGES THAT QUALIPHY'S FEES FOR SERVICES ARE BASED UPON THESE
            LIMITATIONS, AND THAT THE PRACTICE HAS VOLUNTARILY AGREED TO THE
            LIMITATIONS AS A CONDITION OF RECEIVING THE SERVICES PROVIDED BY
            QUALIPHY. QUALIPHY'S TOTAL LIABILITY ARISING OUT OF OR RELATED TO
            THIS AGREEMENT FOR ANY CLAIMS OF ANY NATURE SHALL NOT EXCEED THE
            TOTAL AMOUNT OF FEES PAID BY THE PRACTICE TO QUALIPHY FOR SERVICES
            RENDERED UNDER THIS AGREEMENT DURING THE TWELVE (12) MONTHS
            IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO THE CLAIM, EXCLUDING
            ANY COSTS ASSOCIATED WITH MEDICATION. IN NO EVENT SHALL QUALIPHY BE
            LIABLE FOR ANY CONSEQUENTIAL, SPECIAL, INDIRECT, INCIDENTAL,
            PUNITIVE, OR EXEMPLARY DAMAGES, COSTS, EXPENSES, OR LOSSES,
            INCLUDING BUT NOT LIMITED TO LOST PROFITS, LOST DATA, BUSINESS
            INTERRUPTION, OR OTHER ECONOMIC LOSS, EVEN IF ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            FOR THE AVOIDANCE OF DOUBT, QUALIPHY IS NOT LIABLE FOR ANY
            TREATMENTS PROVIDED BY THE PRACTICE AND ITS PROVIDERS. PRACTICE
            AGREES TO RELEASE AND WAIVE ANY AND ALL CLAIMS FOR LIABILITY AGAINST
            QUALIPHY FOR ANY POOR OUTCOMES OF ANY PROCEDURES, TREATMENTS,
            DIAGNOSIS, MEDICATIONS OR CARE FURNISHED BY OR THROUGH QUALIPHY.
            QUALIPHY IS NOT RESPONSIBLE IN ANY WAY FOR FOR THE OUTCOME OF
            TREATMENTS.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            FURTHERMORE, QUALIPHY SHALL HAVE NO LIABILITY TO THE PRACTICE FOR
            DAMAGES RESULTING FROM: (A) AN ACT OR OMISSION BY ANY AUTHORIZED
            USER TO OR USE OF THE SERVICES OR AN AUTHORIZED USER'S ACCESS
            CREDENTIALS, THAT DOES NOT STRICTLY COMPLY WITH THIS AGREEMENT AND
            THE SPECIFICATIONS; (B) THE PRACTICE'S OR ITS AUTHORIZED USER'S
            INTERNET CONNECTIVITY; (C) FORCE MAJEURE EVENTS; (D) FAILURE,
            INTERRUPTION, OUTAGE, OR OTHER PROBLEM WITH ANY SOFTWARE, HARDWARE,
            SYSTEM, NETWORK, FACILITY, OR OTHER MATTER SUPPLIED BY QUALIPHY
            PURSUANT TO THIS AGREEMENT; (E) SCHEDULED OR UNSCHEDULED DOWNTIME;
            (F) DISABLING, SUSPENSION, OR TERMINATION OF THE SERVICES; (G) ANY
            INACCURATE DATA OR OTHER INFORMATION FURNISHED BY OR ON BEHALF OF
            THE PRACTICE; (H) ANY TECHNICAL FAILURES IN QUALIPHY’S INTERFACE,
            INCLUDING BUT NOT LIMITED TO ANY FAILURE, INTERRUPTION, OUTAGE, ANY
            LOST DATA AS A RESULT OF ANY TECHNOLOGICAL ERROR, OR OTHER PROBLEM
            WITH ANY SOFTWARE, HARDWARE, SYSTEM, NETWORK, OR FACILITY; (I) AN
            ACT OR OMISSION BY THE PRACTICE OR ITS PROVIDERS; (J) PATIENT
            NON-COMPLIANCE WITH PRESCRIBED TREATMENTS; (K) ERRORS IN THE MEDICAL
            HISTORY OR INFORMATION PROVIDED BY THE PRACTICE; OR (L) ISSUES
            ARISING FROM THE HANDLING, DISPENSING, OR ADMINISTRATION OF ANY
            PRESCRIBED MEDICATION BY THIRD PARTIES, INCLUDING PHARMACIES.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            QUALIPHY'S LIABILITY IS STRICTLY LIMITED TO THE PERFORMANCE OF THE
            PROFESSIONAL SERVICES AS OUTLINED IN THIS AGREEMENT AND DOES NOT
            EXTEND TO ANY OUTCOMES, ADVERSE EFFECTS, OR LONG-TERM IMPACTS OF
            TREATMENTS OR PRESCRIPTIONS PROVIDED.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            HE PRACTICE EXPLICITLY WAIVES ANY RIGHT TO RECOVER DAMAGES FROM
            QUALIPHY IN EXCESS OF THE LIMITATIONS SET FORTH HEREIN, INCLUDING
            BUT NOT LIMITED TO ANY CLAIM FOR LOST PROFITS, BUSINESS
            INTERRUPTION, OR PUNITIVE DAMAGES. THE PRACTICE AGREES THAT THIS
            WAIVER IS A MATERIAL INDUCEMENT FOR QUALIPHY TO ENTER INTO THIS
            AGREEMENT AND PROVIDE SERVICES.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                13. Nondiscrimination.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Neither the Practice nor Qualiphy (or any provider provided by
            Practice or Qualiphy) will differentiate or discriminate in the
            providing of services on the basis of race, color, national origin,
            ancestry, religion, sex, marital status, sexual orientation, age,
            medical condition, medical history, genetics, evidence of
            insurability, or claims history, in violation of any applicable
            state, federal or local law or regulation, including, without
            limitation, the Age Discrimination Act of 1975, the Americans with
            Disabilities Act and all regulations issued pursuant thereto and as
            may be amended from time to time.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                14. Confidential Information.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
          </span>
          <a id="bookmark_id.44sinio" />
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              14.1 Confidential Information.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            All non-public, confidential, or proprietary information of either
            party ("Confidential Information"), including but not limited to
            information about medical providers, exam questions, technology
            built, templated exams, business affairs, products, services,
            methodologies, intellectual property, trade secrets, third-party
            confidential information, and other sensitive or proprietary
            information, disclosed by one party (the "Disclosing Party") to the
            other party (the "Receiving Party"), whether disclosed orally or in
            written, electronic, or other forms or media, or otherwise learned
            by the Receiving Party in connection with this Agreement, is
            confidential. This Confidential Information is solely for use in
            performing this Agreement and may not be disclosed or copied unless
            authorized by the Disclosing Party in writing. The Receiving Party
            shall protect and safeguard the confidentiality of the Disclosing
            Party's Confidential Information with at least the same degree of
            care as it would protect its own Confidential Information, but in no
            event with less than a commercially reasonable degree of care.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Confidential Information does not include any information that: (a)
            is or becomes generally available to the public other than as a
            result of the Receiving Party's breach of this Agreement; (b) is
            obtained by the Receiving Party on a non-confidential basis from a
            third party that was not legally or contractually restricted from
            disclosing such information; (c) the Receiving Party can establish
            by documentary evidence was in its possession prior to the
            Disclosing Party's disclosure; (d) was or is independently developed
            by the Receiving Party without using any of the Disclosing Party's
            Confidential Information; or (e) is required to be disclosed under
            applicable law, regulation, or a valid court order.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The Receiving Party shall be responsible for any breach of this
            Section caused by its employees, contractors, agents, or
            representatives. Upon the expiration or termination of the
            Agreement, at the Disclosing Party's written request, the Receiving
            Party shall promptly return or destroy all copies of the Disclosing
            Party's Confidential Information and certify in writing that such
            information has been destroyed. Each party's obligations under this
            Section will survive the termination or expiration of this Agreement
            for a period of 24 months, except for Confidential Information that
            constitutes a trade secret, which shall remain protected for as long
            as it remains a trade secret.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              14.2 Non-Replication.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            The Practice agrees that it shall not replicate, reverse engineer,
            or copy Qualiphy’s technology, business model, workflows, or service
            offerings. The Practice further agrees that it shall not share,
            disclose, or provide access to any information about Qualiphy’s
            technology, business model, workflows, or service offerings to any
            third party, including competitors or potential competitors of
            Qualiphy.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              14.3 Non-Solicitation.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            The Practice agrees that it shall not, directly or indirectly,
            solicit, contact, or attempt to solicit or contact any clients,
            customers, or providers of Qualiphy for the purpose of offering
            services that are similar to or competitive with those provided by
            Qualiphy. The Practice also agrees not to induce or attempt to
            induce any clients, customers, or providers of Qualiphy to terminate
            their relationship with Qualiphy. Additionally, the Practice agrees
            not to solicit, recruit, or attempt to solicit or recruit any
            employee, independent contractor, or agent of Qualiphy for
            employment or engagement with the Practice or any third party. The
            Practice agrees not to induce or attempt to induce any employee,
            independent contractor, or agent of Qualiphy to terminate their
            employment or engagement with Qualiphy or to divulge any
            confidential or proprietary information related to Qualiphy’s
            business, clients, or technology.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              14.4 Confidentiality of Client Information.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            The Practice agrees that it shall not, during the term of this
            Agreement and at any time thereafter, disclose, share, or use for
            any purpose other than the performance of its obligations under this
            Agreement any confidential or proprietary information related to
            Qualiphy’s clients, customers, or providers. The Practice shall take
            all necessary precautions to protect the confidentiality of such
            information and shall immediately notify Qualiphy of any
            unauthorized use or disclosure.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              14.5 Damages and Remedies.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            In the event of a breach of this section by the Practice, Qualiphy
            shall be entitled to seek all available legal and equitable
            remedies, including but not limited to injunctive relief, specific
            performance, and monetary damages. The Practice acknowledges that
            any breach of this section may cause irreparable harm to Qualiphy
            for which monetary damages may be inadequate and agrees that
            Qualiphy shall be entitled to seek injunctive relief without the
            necessity of posting a bond. Additionally, the Practice agrees to
            pay Qualiphy liquidated damages in the amount of $50,000 per
            violation, which the Parties agree represents a reasonable estimate
            of the damages that would result from such a breach. This remedy
            shall be in addition to any other remedies available under this
            Agreement, at law, or in equity.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              14.6 Restriction on Soliciting Employees.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            In consideration of Qualiphy providing Confidential Information to
            the Practice in connection with this Agreement, the Practice
            covenants that during the Term and for a period of 24 months
            immediately following the expiration or termination of this
            Agreement, the Practice will not, directly or indirectly: (a)
            solicit or attempt to solicit any of the employees or independent
            contractors of Qualiphy, either for the Practice’s own account or on
            behalf of any other entity; (b) induce or attempt to induce any
            employee or independent contractor of Qualiphy to leave their
            employment or engagement with Qualiphy; or (c) employ or engage any
            such person within 12 months of their termination of employment or
            engagement with Qualiphy
          </span>
        </p>
        <p
          style={{
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <a id="bookmark_id.z337ya" />
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                15. Dispute Resolution.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            In the event that any disagreement, dispute, or claim arises among
            the Parties hereto with respect to the enforcement or interpretation
            of this Agreement or any specific terms and provisions hereof or
            with respect to whether an alleged breach or default hereof has or
            has not occurred (collectively, a “
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Dispute
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”), such Dispute shall be settled in accordance with the following
            procedures:
          </span>
        </p>
        <p
          style={{
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                15.1 Meet and Confer.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            In the event of a Dispute among the Parties hereto, a Party may give
            written notice to all other Parties setting forth the nature of such
            Dispute (the “
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Dispute Notice
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”).
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The Parties shall meet and confer to discuss the Dispute in good
            faith within ten (10) days following the other Parties’ receipt of
            the Dispute Notice in an attempt to resolve the Dispute.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            All representatives shall meet at such date(s) and time(s) as are
            mutually convenient to the representatives of each participant
            within the “Meet and Confer Period” (as defined herein below).
          </span>
        </p>
        <p
          style={{
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                15.2 Mediation.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            If the Parties are unable to resolve the Dispute within thirty (30)
            days following the date of receipt of the Dispute Notice by the
            other Parties (the “
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Meet and Confer Period
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”), then the Parties shall attempt in good faith to settle the
            Dispute through nonbinding mediation under the Rules of Practice and
            Procedures (the “
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Rules
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”) of the American Arbitration Association (“
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              AAA
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”) or such other neutral service as the Parties may agree.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            A single disinterested third party mediator located in Los Angeles
            County, California shall be selected by AAA in accordance with its
            then current Rules.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The parties to the Dispute shall share the expenses of the mediator
            and the other costs of mediation on a pro rata basis.
          </span>
        </p>
        <p
          style={{
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                15.3 Arbitration.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Any Dispute which cannot be resolved by the Parties within sixty
            (60) days following the end of the Meet and Confer Period shall be
            resolved by final and binding arbitration (the “
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Arbitration
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”).
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The Arbitration shall be initiated and administered by and in
            accordance with the then current Rules of AAA.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The Arbitration shall be held before a single disinterested
            third-party arbitrator selected in accordance with the then current
            Rules of the American Arbitration Association (“AAA”), in Los
            Angeles County, unless the parties mutually agree to have such
            proceeding in some other locale; the exact time and location shall
            be decided by the arbitrator in accordance with the then current
            Rules of AAA.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The arbitrator shall apply California substantive law, or federal
            substantive law where state law is preempted.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The arbitrator selected shall have the power to enforce the rights,
            remedies, duties, liabilities, and obligations of discovery by the
            imposition of the same terms, conditions, and penalties as can be
            imposed in like circumstances in a civil action by a court of
            competent jurisdiction of the State of California.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The arbitrator shall have the power to grant all legal and equitable
            remedies provided by California law and award compensatory damages
            provided by California law, except that punitive damages shall not
            be awarded.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The arbitrator shall prepare in writing and provide to the Parties
            an award including factual findings and the legal reasons on which
            the award is based.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The arbitration award may be enforced through an action thereon
            brought in the Superior Court for the State of California in Los
            Angeles County.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The prevailing Party in any Arbitration hereunder shall be awarded
            reasonable attorneys’ fees, expert and non-expert witness costs and
            any other expenses incurred directly or indirectly with said
            Arbitration, including without limitation the fees and expenses of
            the arbitrator.
          </span>
        </p>
        <p
          style={{
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            15.4 THIS ELECTION OF AN ALTERNATIVE DISPUTE PROCESS IS AN
            AFFIRMATIVE WAIVER OF THE PARTIES’ RIGHTS TO A JURY TRIAL UNDER
            CALIFORNIA LAW.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            BY SIGNING BELOW, EACH PARTY IS EXPLICITLY WAIVING JURY TRIAL AND
            AUTHORIZING ANY AND ALL PARTIES TO FILE THIS WAIVER WITH ANY COURT
            AS THE WAIVER REQUIRED UNDER CALIFORNIA LAW.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            pageBreakAfter: "avoid",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16. Miscellaneous.
              </span>
            </u>
          </strong>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            lineHeight: "12pt",
            verticalAlign: "top",
            textAlign: "justify",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              API Access and Documentation
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            lineHeight: "12pt",
            verticalAlign: "top",
            textAlign: "justify",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Grant of API Access.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Qualiphy PC ("Qualiphy") hereby grants a non-exclusive, revocable,
            limited license to access and use Qualiphy’s Application Programming
            Interface (“API”) and associated documentation solely for the
            purpose of integrating Qualiphy’s services into Practices systems in
            accordance with the terms of this Agreement. This access is provided
            to facilitate the delivery of services as defined under this
            Agreement and shall be used exclusively to support the operations
            and functionalities specified herein.
          </span>
        </p>
        <p
          style={{
            marginTop: "12pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            lineHeight: "12pt",
            verticalAlign: "top",
            textAlign: "justify",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Usage Restrictions.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Practice agrees to use the API and associated documentation in
            strict accordance with the terms of this Agreement. The following
            restrictions apply:
          </span>
        </p>
        <ol style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "12pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              lineHeight: "12pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "22.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>Authorized Use Only:</span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              {" "}
              Practice shall use the API only for the purposes expressly
              permitted by this Agreement and in compliance with all applicable
              laws and regulations. Any use of the API beyond what is permitted
              under this Agreement is strictly prohibited.
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              lineHeight: "12pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "22.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>
                No Reverse Engineering:
              </span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              {" "}
              Practice shall not, and shall not permit any third party to,
              modify, reverse engineer, decompile, or disassemble the API or any
              software or code related to the API, nor create derivative works
              based on the API or its documentation.
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              lineHeight: "12pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "22.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>
                No Unauthorized Access:
              </span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              {" "}
              Practice shall not use the API to gain unauthorized access to any
              systems, data, or networks, and shall not permit any unauthorized
              third party to access the API. Practice must ensure that access to
              the API is restricted to only those individuals or systems
              necessary to perform the functions under this Agreement.
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              lineHeight: "12pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "22.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>
                Data Privacy and Security:
              </span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              {" "}
              Practice agrees to implement and maintain robust data privacy and
              security measures to protect the API and any data transmitted
              through the API from unauthorized access, use, or disclosure.
              Practice is responsible for any breach of data privacy or security
              resulting from misuse or abuse of the API.
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              lineHeight: "12pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "22.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>
                Rate Limits and Usage Monitoring:
              </span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              {" "}
              Qualiphy reserves the right to impose rate limits on API usage and
              to monitor usage to ensure compliance with this Agreement.
              Practice agrees not to exceed any rate limits imposed by Qualiphy
              and acknowledges that exceeding such limits may result in
              suspension or termination of API access.
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              lineHeight: "12pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "22.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>
                Reporting and Notifications:
              </span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              {" "}
              Practice shall immediately notify Qualiphy in writing if it
              becomes aware of any misuse, abuse, or unauthorized use of the
              API. Practice agrees to cooperate fully with Qualiphy in
              investigating and addressing any such misuse or abuse.
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              textIndent: "-0.1pt",
              lineHeight: "12pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "22.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>
                Termination of API Access:
              </span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              {" "}
              Qualiphy reserves the right to terminate or suspend API access at
              any time, with or without cause, upon written notice to Practice.
              Upon termination or expiration of this Agreement, Practice access
              to the API shall immediately cease, and Practice shall delete any
              API keys or access credentials provided by Qualiphy.
            </span>
          </li>
          <li
            style={{
              marginTop: "0pt",
              marginLeft: "0.1pt",
              marginBottom: "12pt",
              textIndent: "-0.1pt",
              lineHeight: "12pt",
              fontFamily: '"Times New Roman"',
              verticalAlign: "-0.5pt",
              listStylePosition: "inside",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "22.1pt",
                font: '7pt "Times New Roman"',
                display: "inline-block",
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            <span style={{ verticalAlign: "top" }}> </span>
            <strong>
              <span style={{ verticalAlign: "top" }}>
                Indemnification for Misuse:
              </span>
            </strong>
            <span style={{ verticalAlign: "top" }}>
              {" "}
              Practice agrees to indemnify, defend, and hold harmless Qualiphy
              and its affiliates from and against any and all claims, damages,
              liabilities, costs, and expenses (including reasonable attorneys’
              fees) arising out of or related to Practice misuse or abuse of the
              API, or any breach of this Section.{" "}
            </span>
            <a id="bookmark_id.3j2qqm3" />
          </li>
        </ol>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            pageBreakAfter: "avoid",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.1 No Publicity.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Neither party shall issue or release any announcement, statement,
            press release, or other publicity or marketing materials relating to
            this Agreement, or otherwise use the other party’s trademarks,
            service marks, trade names, logos, symbols, or brand names, in each
            case, without the prior written consent of the other party.{" "}
          </span>
          <a id="bookmark_id.1y810tw" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.2 Notice.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            All notices, requests, consents, claims, demands, waivers, and other
            communications hereunder (each, a “
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Notice
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ”) shall be in writing and addressed to the parties at the addresses
            set forth on the first page of this Agreement (or to such other
            address that may be designated by the receiving party from time to
            time in accordance with this Section). All Notices shall be
            delivered by personal delivery, nationally recognized overnight
            courier (with all fees pre-paid), facsimile or email (with
            confirmation of transmission) or certified or registered mail (in
            each case, return receipt requested, postage pre-paid). Except as
            otherwise provided in this Agreement, a Notice is effective only (a)
            upon receipt by the receiving party; and (b) if the party giving the
            Notice has complied with the requirements of this Section.{" "}
          </span>
          <a id="bookmark_id.4i7ojhp" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.3 Entire Agreement; Order of Precedence.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            This Agreement, together with all Schedules and Exhibits and any
            other documents incorporated herein by reference, constitutes the
            sole and entire agreement of the parties to this Agreement with
            respect to the subject matter contained herein, and supersedes all
            prior and contemporaneous understandings and agreements, both
            written and oral, with respect to such subject matter. In the event
            of any conflict between the terms and provisions of this Agreement
            and those of any Schedule or Exhibit, then the terms of this
            Agreement shall control unless expressly set forth otherwise in the
            applicable Schedule or Exhibit.{" "}
          </span>
          <a id="bookmark_id.2xcytpi" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.4 Assignment.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Practice may not assign, transfer, or delegate any or all of its
            rights or obligations under this Agreement, including by operation
            of law, change of control, or merger, without the prior written
            consent of Qualiphy, which consent shall not be unreasonably
            withheld or delayed. Qualiphy may only assign this Agreement to any
            of its wholly owned affiliates or successors of its business. This
            Agreement shall be binding upon and shall inure to the benefit of
            the parties hereto and their respective successors and permitted
            assigns.
          </span>
          <a id="bookmark_id.1ci93xb" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.5 No Third-Party Beneficiaries.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            This Agreement is for the sole benefit of the parties hereto and
            their respective successors and permitted assigns and nothing
            herein, express or implied, is intended to or shall confer upon any
            other Person any legal or equitable right, benefit, or remedy of any
            nature whatsoever, under or by reason of this Agreement.
          </span>
          <a id="bookmark_id.3whwml4" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.6 Amendment and Modification; Waiver.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            This Agreement may be amended, modified, or supplemented only by an
            agreement in writing signed by each party hereto. No failure to
            exercise any rights, remedy, power or privilege (
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              “Right(s)”
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ) arising from this Agreement shall operate or be construed as a
            waiver thereof. No single or partial exercise of any Right hereunder
            precludes any other or further exercise thereof or the exercise of
            any other Right.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.7 Governmental Requirements.
              </span>
            </u>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              {" "}
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            This Agreement is subject to the requirements of all applicable laws
            and regulations. The Parties agree to negotiate in good faith to
            amend this Agreement to comply with any governmental requirements
            affecting the Agreement, including without limitation, requirements
            affecting reimbursement for health care services. If the Parties are
            unable to negotiate a mutually acceptable amendment to comply with
            any provision of law, regulation, or ruling materially affecting
            this Agreement, either Party may initiate a voluntary termination of
            this Agreement on 30 days’ notice.
          </span>
          <a id="bookmark_id.2bn6wsx" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.8 Severability.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            No invalidity, illegality, or unenforceability of any provision
            herein in any jurisdiction, shall affect any other term or provision
            of this Agreement or invalidate or render such provision
            unenforceable in any other jurisdiction. If any provision is
            determined to be invalid, illegal, or unenforceable, the parties
            hereto shall negotiate in good faith to modify this Agreement so as
            to affect the original intent of the parties as closely as possible.
          </span>
          <a id="bookmark_id.qsh70q" />
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.9 Governing Law.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            This Agreement shall be governed by and construed in accordance with
            the internal laws of the State of California without giving effect
            to any choice or conflict of law provision or rule that would cause
            the application of laws of any other jurisdiction.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.10 Force Majeure.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Neither Party will be liable nor deemed to be in default for any
            delay, interruption or failure in performance under this Agreement
            caused by or resulting, directly or indirectly, from acts of God,
            civil or military authority, war, terrorism, vandalism, riots, civil
            disturbances, accidents, fires, explosions, earthquakes, floods,
            failure of transportation infrastructure, disruption of public
            utilities, supply chain interruptions, breakdown of machinery,
            strike or other work interruptions by either Party’s employees, or
            any similar cause beyond the reasonably control of either party.
            However, both Parties will make good faith efforts to perform under
            this Agreement in the event of any such circumstances.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.11 Advice of Counsel.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            The Parties have each been advised to seek independent legal counsel
            in entering into this Agreement and the transactions described
            herein. In the event a Party chooses not to seek independent legal
            counsel, that party does so freely and knowingly and waives any such
            rights to coun
          </span>
          <a id="bookmark_id.3as4poj" />
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            sel.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.12 Equitable Relief; Cumulative Remedies.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Each party acknowledges that a breach of Confidentiality or with
            respect to Qualiphy, Non-Solicitation, may cause the non-breaching
            party irreparable damages, for which an award of damages would not
            be adequate compensation. In the event of such breach or threatened
            breach, the non-breaching party will be entitled to seek equitable
            relief. Except as expressly set forth in this Agreement, the right
            and remedies under this Agreement are cumulative and in addition to
            any other rights or remedies available at law or in equity or
            otherwise.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.13 Counterparts.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            This Agreement may be executed in counterparts by digital signature
            and delivered by electronic mediums including email and facsimile,
            each of which shall be deemed an original, but all of which together
            shall constitute one and the same instrument.
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Counterparts may be delivered via facsimile, electronic mail
            (including pdf or any electronic signature complying with the U.S.
            federal ESIGN Act of 2000, e.g.,
          </span>
          <a href="http://qualiphy.me" style={{ textDecoration: "none" }}>
            <span
              style={{
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                color: "#000000",
              }}
            >
              qualiphy.me
            </span>
          </a>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ) or other transmission method and any counterpart so delivered
            shall be deemed to have been duly and validly delivered and be valid
            and effective for all purposes.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <u>
              <span
                style={{
                  fontFamily: '"Times New Roman"',
                  verticalAlign: "top",
                }}
              >
                16.14 Authority to Sign.
              </span>
            </u>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            Practice represents and warrants that the individual signing on
            behalf of the Practice is duly authorized to sign this Agreement on
            behalf of the Practice, and the Medical Director has reviewed and
            approved this Agreement.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{
              fontFamily: '"Times New Roman"',
              fontVariant: "small-caps",
              verticalAlign: "top",
            }}
          >
            [SIGNATURE PAGE FOLLOWS]
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            pageBreakBefore: "always",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            IN WITNESS WHEREOF, the parties hereto have executed this Agreement
            as of the date when fully signed by all parties below.
          </span>
        </p>
        <RXForm
          data={data}
          signImages={signImages}
          setSignImages={setSignImages}
          setSignType={(type) => setSignType(type)}
          isFirstSign={true}
          handleOnSignatureClick={handleOnSignatureClick}
          filledSignatureIds={filledSignatureIds}
          setFilledSignatureIds={setFilledSignatureIds}
          handleOnSignatureChange={handleOnSignatureChange}
        />
        <div>
          <p className="mt-0 ml-1 mb-3 text-center text-sm font-bold leading-normal tracking-wide uppercase">
            EXHIBIT A
          </p>
          <p className="m-0.5 mb-3 text-center text-sm font-bold leading-normal tracking-wide uppercase">
            FEES AND CREDIT CARD AUTHORIZATION
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            <span>1. </span>
            <strong>Service Usage and Flexibility</strong>
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            The Practice may choose when to use Qualiphy’s Services during
            specified hours of operation. Upon establishing an account with
            Qualiphy, the Practice will have access to initiate private video
            room links for consultations and treatments as needed.
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            <span>2. </span>
            <strong>Pricing and Fee Structure</strong>
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            Qualiphy’s rates are clearly published next to each service type in
            the platform and are subject to updates. Current pricing includes:
          </p>
          <ul className="list-disc list-inside ml-4 text-justify">
            <li>Good Faith Exam: $27.99</li>
            <li>Good Faith Exam with Lab Review: $37.99</li>
            <li>Consultations with Prescriptions: $49.99</li>
            <li>Backup Follow-Up Care: $17.99</li>
            <li>
              Consultations with Medication and Shipping: Displayed at the time
              of service.
            </li>
          </ul>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            Qualiphy provides bundled pricing that reflects a comprehensive
            range of services required to deliver high-quality care. This
            includes, but is not limited to: Utilization of Qualiphy’s licensed
            providers and clinical direction. Integration fees for API access
            and technology licensing. Chart reviews by collaborating physicians.
            Medication costs, including dispensing and shipping. Supplies
            delivered with medications.
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            The total price displayed may include a consultation fee and a
            medication fee but is not itemized to reflect every underlying
            service or cost component. This bundling ensures{" "}
            <strong>
              clarity and simplicity in billing without altering the total
              price.
            </strong>
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            However, pricing is subject to change at Qualiphy’s discretion.
            Should Qualiphy introduce a subscription model, the Practice will
            receive 30 days’ written notice via email with full details of the
            new pricing structure.
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            <span>3. Payment Process</span>
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            At the time of transferring a patient to Qualiphy’s care, the
            agreed-upon fee will be charged to the Practice’s credit card on
            file. This card will also be used for any future subscription
            payments, if applicable.
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            <span>4. Authorization and Terms</span>
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            Qualiphy does not currently charge any sign-up or monthly
            subscription fees.
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            By completing the form below, the Practice authorizes Qualiphy to
            process payments according to the terms outlined in this Agreement.
            This authorization remains in effect until terminated in writing by
            the Practice. It is the Practice’s responsibility to notify Qualiphy
            promptly of any changes to the credit card information. Failure to
            maintain a valid credit card on file will result in suspension of
            services.
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            Acknowledgment and Agreement:
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            By signing below, I, as an authorized representative of the Practice
            named above, hereby authorize Qualiphy PC (“Qualiphy”) to charge the
            credit card provided in the portal for services rendered, as per the
            terms of the Qualiphy Services Agreement.
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            I understand that charges will be made at the time of patient
            transfer or upon initiation of services.
          </p>
          <p className="mt-0 ml-1 mb-3 text-normal text-justify">
            I acknowledge that I may not receive additional notice of these
            charges and that they will adhere to the pricing displayed in the
            Qualiphy platform at the time of service.
          </p>
        </div>

        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            I understand that the total price reflects bundled services,
            including provider utilization, API access, medication costs,
            technology licensing, and clinical oversight, which may be broken
            down into consultation and medication fees but not further itemized.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            I agree to notify Qualiphy in writing of any changes to my payment
            method or account details.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            I certify that I will not dispute authorized charges with my credit
            card provider or bank, provided the transactions comply with this
            authorization and the terms of the Agreement.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            I agree to reimburse Qualiphy for any out-of-pocket costs resulting
            from chargebacks initiated by me.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            marginBottom: "12pt",
            textIndent: "-0.1pt",
            lineHeight: "12pt",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Credit Card Authorization Form
          </span>
        </p>
        <div className="mt-0 ml-[0.1pt] -indent-[0.1pt] text-justify leading-normal align-top">
          <div className="western text-justify mb-4">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Practice Name:
            </label>
            <input
              id="name_of_practice_2"
              type="text"
              name="name_of_practice"
              value={mdFormData?.name_of_practice}
              onChange={(e) => handleChangeMDForm(e)}
              className="border border-gray-300 rounded p-2 w-1/2"
              disabled={isMD}
            />
          </div>
        </div>

        <div className="mt-0 ml-[0.1pt] -indent-[0.1pt] text-justify leading-normal align-top w-full md:w-1/2">
          <div id={"signature2"} className="western text-justify mb-4">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Cardholder Signature:
            </label>
            {signImages.adminPracticeSign &&
            filledSignatureIds.includes("signature_2") ? (
              <SignatureComponent
                allButtonIds={[
                  "signature_1",
                  "signature_2",
                  "signature_3",
                  "submit",
                ]}
                handleOnSignatureClick={() =>
                  handleOnSignatureClick({
                    type: "adminPracticeSign",
                    fillId: "signature_2",
                  })
                }
                disabled={isMD}
                loading={loading}
                removeSignature={removeSignature}
                userSignauter={signImages.adminPracticeSign}
                id={"signature_2"}
                onChange={() =>
                  handleOnSignatureChange({
                    type: "adminPracticeSign",
                    fillId: "signature_2",
                  })
                }
              />
            ) : null}
            {!signImages.adminPracticeSign ||
            !filledSignatureIds.includes("signature_2") ? (
              <CustomButton
                disabled={isMD}
                id={"signature_2"}
                className="px-4"
                labelColor="black"
                label="Sign"
                onClick={() =>
                  handleOnSignatureClick({
                    type: "adminPracticeSign",
                    fillId: "signature_2",
                  })
                }
              />
            ) : null}
            {
              mdFormErrors?.signature_2 && (
                <span className="text-red-500 text-sm error-message">
                  {mdFormErrors?.signature_2}
                </span>
              ) // Optional: Display error message if signature is empty
            }
          </div>
        </div>
        <div className="mt-0 ml-[0.1pt] -indent-[0.1pt] text-justify leading-normal align-top">
          <div className="western text-justify mb-4">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Date:
            </label>
            <input
              type="text"
              disabled
              value={currentDate}
              id="date-signed"
              className="border border-gray-300 rounded p-2 w-1/2"
            />
          </div>
        </div>
        <p
          style={{
            margin: "0pt 1pt 12pt 0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            widows: 0,
            orphans: 0,
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                fontFamily: '"Times New Roman"',
                verticalAlign: "-0.5pt",
              }}
            >
              &nbsp;
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              EXHIBIT “B”
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              HIPAA BUSINESS ASSOCIATE AGREEMENT
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ARTICLE I
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            PREAMBLE &amp; DEFINITIONS
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 1.1
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Pursuant to the Health Insurance Portability and Accountability Act
            of 1996, as amended (
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "HIPAA"
            </span>
          </strong>{" "}
          <input
            type="text"
            id="date-signed"
            className="border border-gray-300 rounded p-2 w-1/3"
            name="name_of_practice"
            value={mdFormData?.name_of_practice}
            onChange={(e) => handleChangeMDForm(e)}
            disabled={isMD}
          />
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "Covered Entity"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ) and Qualiphy PC, a California professional medical corporation,
            with offices located at 113 N. San Vicente Boulevard 3rd Floor,
            Beverly Hills, CA 90211 (the{" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "Business Associate"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ), a Texas limited liability company, enter into this Business
            Associate Agreement (
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "BAA"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ) as of the{" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "Effective Date"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            defined in the Management Services Agreement that addresses the
            HIPAA requirements with respect to "business associates," as defined
            under the privacy, security, breach notification, and enforcement
            rules at 45 C.F.R. Part 160 and Part 164 (
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "HIPAA Rules"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ). A reference in this BAA to a section in the HIPAA Rules means the
            section as in effect or as amended.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 1.2
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            This BAA is intended to ensure that Business Associate will
            establish and implement appropriate safeguards for the Protected
            Health Information (
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "PHI"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ) (as defined under the HIPAA Rules) that Business Associate may
            receive, create, maintain, use, or disclose in connection with the
            functions, activities, and services that Business Associate performs
            for Covered Entity. The functions, activities, and services that
            Business Associate performs for Covered Entity are defined in
            Managing Servicing Agreement (the{" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "Underlying Agreement"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ).
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 1.3
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Pursuant to changes required under the Health Information Technology
            for Economic and Clinical Health Act of 2009 (the{" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "HITECH Act"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ) and under the American Recovery and Reinvestment Act of 2009 (
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "ARRA"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ), this BAA also reflects federal breach notification requirements
            imposed on Business Associate when "Unsecured PHI" (as defined under
            the HIPAA Rules) is acquired by an unauthorized party, and the
            expanded privacy and security provisions imposed on business
            associates.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 1.4
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Unless the context clearly indicates otherwise, the following terms
            in this BAA shall have the same meaning as those terms in the HIPAA
            Rules: Breach, Data Aggregation, Designated Record Set, disclosure,
            Electronic Media, Electronic Protected Health Information (ePHI),
            Health Care Operations, individual, Minimum Necessary, Notice of
            Privacy Practices, Required by Law, Secretary, Security Incident,
            Subcontractor, Unsecured PHI, and use.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 1.5
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            A reference in this BAA to the Privacy Rule means the Privacy Rule,
            in conformity with the regulations at 45 C.F.R. Parts 160-164 (the{" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "Privacy Rule"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ) as interpreted under applicable regulations and guidance of
            general application published by HHS, including all amendments
            thereto for which compliance is required, as amended by the HITECH
            Act, ARRA, and the HIPAA Rules.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ARTICLE II
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            GENERAL OBLIGATIONS OF BUSINESS ASSOCIATE
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.1
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees not to use or disclose PHI, other than as
            permitted or required by this BAA or as Required by Law, or if such
            use or disclosure does not otherwise cause a Breach of Unsecured
            PHI.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.2
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to use appropriate safeguards and comply
            with Subpart C of 45 C.F.R. Part 164 with respect to ePHI, to
            prevent the use or disclosure of PHI other than as provided for by
            the BAA.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.3
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business
          </span>
          <span style={{ verticalAlign: "top" }}> </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Associate agrees to mitigate, to the extent practicable, any harmful
            effect that is known to Business Associate as a result of a use or
            disclosure of PHI by Business Associate in violation of this BAA's
            requirements or that would otherwise cause a Breach of Unsecured
            PHI.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.4
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The Business Associate agrees to the following breach notification
            requirements:
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.4(a)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to report to Covered Entity any Breach of
            Unsecured PHI not provided for by the BAA of which it becomes aware
            within [NUMBER] calendar days of "discovery" within the meaning of
            the HITECH Act. Such notice shall include the identification of each
            individual whose Unsecured PHI has been, or is reasonably believed
            by Business Associate to have been, accessed, acquired, or disclosed
            in connection with such Breach. Business Associate also shall
            provide any additional information reasonably requested by Covered
            Entity for purposes of investigating the Breach and any other
            available information that Covered Entity is required to include to
            the individual under 45 C.F.R. § 164.404(c) at the time of
            notification or promptly thereafter as information becomes
            available. Business Associate's notification of a Breach of
            Unsecured PHI under this Section shall comply in all respects with
            each applicable provision of Section 13400 of Subtitle D (Privacy)
            of ARRA, the HIPAA Rules, and related guidance issued by the
            Secretary or the delegate of the Secretary from time to time.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                fontFamily: '"Times New Roman"',
                verticalAlign: "-0.5pt",
              }}
            >
              &nbsp;
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.4(b)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            In the event of Business Associate's use or disclosure of Unsecured
            PHI in violation of HIPAA, the HITECH Act, or ARRA, Business
            Associate bears the burden of demonstrating that notice as required
            under this Section 2.4 was made, including evidence demonstrating
            the necessity of any delay, or that the use or disclosure did not
            constitute a Breach of Unsecured PHI.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                fontFamily: '"Times New Roman"',
                verticalAlign: "-0.5pt",
              }}
            >
              &nbsp;
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.5
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees, in accordance with 45 C.F.R. §§
            164.502(e)(1)(ii) and 164.308(b)(2), if applicable, to require that
            any Subcontractors that create, receive, maintain, or transmit PHI
            on behalf of the Business Associate agree to the same restrictions,
            conditions, and requirements that apply to the Business Associate
            with respect to such information.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.6
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to make available PHI in a Designated
            Record Set to the covered entity as necessary to satisfy Covered
            Entity's obligations under 45 C.F.R. § 164.524.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.6(a)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to comply with an individual's request to
            restrict the disclosure of their personal PHI in a manner consistent
            with 45 C.F.R. § 164.522, except where such use, disclosure, or
            request is required or permitted under applicable law.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.6(b)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business
          </span>
          <span style={{ verticalAlign: "top" }}> </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Associate agrees to charge fees related to providing individuals
            access to their PHI in accordance with 45 C.F.R. § 164.524(c)(4).
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.6(c)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees that when requesting, using, or disclosing
            PHI in accordance with 45 C.F.R. § 164.502(b)(1) that such request,
            use, or disclosure shall be to the minimum extent necessary,
            including the use of a "limited data set" as defined in 45 C.F.R. §
            164.514(e)(2), to accomplish the intended purpose of such request,
            use, or disclosure, as interpreted under related guidance issued by
            the Secretary from time to time.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.7
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to make any amendments to PHI in a
            Designated Record Set as directed or agreed to by the Covered Entity
            pursuant to 45 C.F.R. § 164.526, or to take other measures as
            necessary to satisfy Covered Entity's obligations under 45 C.F.R. §
            164.526.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.8
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to maintain and make available the
            information required to provide an accounting of disclosures to the
            Covered Entity as necessary to satisfy Covered Entity's obligations
            under 45 C.F.R. § 164.528.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.9
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to make its internal practices, books, and
            records, including policies and procedures regarding PHI, relating
            to the use and disclosure of PHI and Breach of any Unsecured PHI
            received from Covered Entity, or created or received by the Business
            Associate on behalf of Covered Entity, available to Covered Entity
            (or the Secretary) for the purpose of Covered Entity or the
            Secretary determining compliance with the Privacy Rule (as defined
            in 1.5).
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.10
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            To the extent that Business Associate is to carry out one or more of
            Covered Entity's obligation(s) under Subpart E of 45 C.F.R. Part
            164, Business Associate agrees to comply with the requirements of
            Subpart E that apply to the Covered Entity in the performance of
            such obligation(s).
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.11
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to account for the following disclosures:
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                width: "0.1pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                fontFamily: '"Times New Roman"',
                verticalAlign: "top",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.11(a)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to maintain and document disclosures of
            PHI and Breaches of Unsecured PHI and any information relating to
            the disclosure of PHI and Breach of Unsecured PHI in a manner as
            would be required for Covered Entity to respond to a request by an
            individual or the Secretary for an accounting of PHI disclosures and
            Breaches of Unsecured PHI.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.11(b)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to provide to Covered Entity, or to an
            individual at Covered Entity's request, information collected in
            accordance with this Section 2.11, to permit Covered Entity to
            respond to a request by an individual or the Secretary for an
            accounting of PHI disclosures and Breaches of Unsecured PHI.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.11(c)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to account for any disclosure of PHI used
            or maintained as an Electronic Health Record (as defined in 5) (
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "EHR"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ) in a manner consistent with 45 C.F.R. § 164.528 and related
            guidance issued by the Secretary from time to time; provided that an
            individual shall have the right to receive an accounting of
            disclosures of EHR by the Business Associate made on behalf of the
            Covered Entity only during the three years prior to the date on
            which the accounting is requested from Covered Entity.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              2.11(d)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            In the case of an EHR that the Business Associate acquired on behalf
            of the Covered Entity as of January 1, 2009, Section 2.11(c) above
            shall apply to disclosures with respect to PHI made by the Business
            Associate from such EHR on or after January 1, 2014. In the case of
            an EHR that the Business Associate acquires on behalf of the Covered
            Entity after January 1, 2009, Section 2.11(c) above shall apply to
            disclosures with respect to PHI made by the Business Associate from
            such EHR on or after the later of January 1, 2011, or the date that
            it acquires the EHR.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.12
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <a id="bookmark_id.1pxezwc" />
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to comply with the "Prohibition on Sale of
            Electronic Health Records or Protected Health Information," as
            provided in Section 13405(d) of Subtitle D (Privacy) of ARRA, and
            the "Conditions on Certain Contacts as Part of Health Care
            Operations," as provided in Section 13406 of Subtitle D (Privacy) of
            ARRA and related guidance issued by the Secretary from time to time.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 2.13
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate acknowledges that, effective on the Effective
            Date of this BAA, it shall be liable under the civil and criminal
            enforcement provisions set forth at 42 U.S.C. § 1320d-5 and 1320d-6,
            as amended, for failure to comply with any of the use and disclosure
            requirements of this BAA and any guidance issued by the Secretary
            from time to time with respect to such use and disclosure
            requirements.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ARTICLE III
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            PERMITTED USES AND DISCLOSURES BY BUSINESS ASSOCIATE
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 3.1
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Uses and Disclosures. Business Associate agrees to receive, create,
            use, or disclose PHI only in a manner that is consistent with this
            BAA, the Privacy Rule, or Security Rule (as defined in 5), and only
            in connection with providing services to Covered Entity; provided
            that the use or disclosure would not violate the Privacy Rule,
            including 45 C.F.R. § 164.504(e), if the use or disclosure would be
            done by Covered Entity. For example, the use and disclosure of PHI
            will be permitted for "treatment, payment, and health care
            operations," in accordance with the Privacy Rule.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 3.2
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .{" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              &nbsp;
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate may use or disclose PHI as Required by Law.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 3.3
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate agrees to make uses and disclosures and requests
            for PHI: Consistent with Covered Entity's Minimum Necessary policies
            and procedures.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 3.4
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business
          </span>
          <span style={{ verticalAlign: "top" }}> </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Associate may not use or disclose PHI in a manner that would violate
            Subpart E of 45 C.F.R. Part 164 if done by the Covered Entity.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ARTICLE IV
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            OBLIGATIONS OF COVERED ENTITY
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 4.1
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Covered Entity shall:
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              4.1(a)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Provide
          </span>
          <span style={{ verticalAlign: "top" }}> </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate with the Notice of Privacy Practices that Covered
            Entity produces in accordance with the Privacy Rule, and any changes
            or limitations to such notice under 45 C.F.R. § 164.520, to the
            extent that such changes or limitations may affect Business
            Associate's use or disclosure of PHI.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              4.1(b)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Notify Business Associate of any restriction on the use or
            disclosure of PHI that Covered Entity has agreed to or is required
            to comply with under 45 C.F.R. § 164.522, to the extent that such
            restriction may affect Business Associate's use or disclosure of PHI
            under this BAA.{" "}
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              4.1(c)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Notify Business Associate of any changes in or revocation of
            permission by an individual to use or disclose PHI, if such change
            or revocation may affect Business Associate's permitted or required
            uses and disclosures of PHI under this BAA.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              4.2(d)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Covered Entity shall not request Business Associate to use or
            disclose PHI in any manner that would not be permissible under the
            Privacy and Security Rule if done by Covered Entity, except as
            provided under Article III of this BAA.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ARTICLE V
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            COMPLIANCE WITH SECURITY RULE
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 5.1
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Business Associate shall comply with the HIPAA Security Rule, which
            shall mean the Standards for Security of Electronic Protected Health
            Information at 45 C.F.R. Part 160 and Subparts A and C of Part 164,
            as amended by ARRA and the HITECH Act. The term{" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "Electronic Health Record"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            or{" "}
          </span>
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              "EHR"
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            {" "}
            as used in this BAA shall mean an electronic record of
            health-related information on an individual that is created,
            gathered, managed, and consulted by authorized health care
            clinicians and staff.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 5.2
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            In accordance with the Security Rule, Business Associate agrees to:
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              5.2(a)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Implement the administrative safeguards set forth at 45 C.F.R. §
            164.308, the physical safeguards set forth at 45 C.F.R. § 164.310,
            the technical safeguards set forth at 45 C.F.R. § 164.312, and the
            policies and procedures set forth at 45 C.F.R. § 164.316, to
            reasonably and appropriately protect the confidentiality, integrity,
            and availability of the ePHI that it creates, receives, maintains,
            or transmits on behalf of Covered Entity as required by the Security
            Rule. Business Associate acknowledges that, effective on the
            Effective Date of this BAA, (a) the foregoing safeguards, policies,
            and procedures requirements shall apply to Business Associate in the
            same manner that such requirements apply to Covered Entity, and (b)
            Business Associate shall be liable under the civil and criminal
            enforcement provisions set forth at 42 U.S.C. § 1320d-5 and 1320d-6,
            as amended from time to time, for failure to comply with the
            safeguards, policies, and procedures requirements and any guidance
            issued by the Secretary from time to time with respect to such
            requirements.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              5.2(b)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Require that any agent, including a Subcontractor, to whom it
            provides such PHI agrees to implement reasonable and appropriate
            safeguards to protect the PHI; and
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              5.2(c)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Report to the Covered Entity any Security Incident of which it
            becomes aware.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{
                fontFamily: '"Times New Roman"',
                verticalAlign: "-0.5pt",
              }}
            >
              &nbsp;
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            ARTICLE VI
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "center",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            MISCELLANEOUS
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 6.1
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The parties agree to take such action as is necessary to amend this
            BAA to comply with the requirements of the Privacy Rule, the
            Security Rule, HIPAA, ARRA, the HITECH Act, the Consolidated
            Appropriations Act, 2021 (CAA-21), the HIPAA Rules, and any other
            applicable law.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 6.2
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            The respective rights and obligations of Business Associate of this
            BAA shall survive the termination of this Management Services
            Agreement.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              Section 6.3.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            BAA shall be interpreted in the following manner:
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              6.3(a)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Any ambiguity shall be resolved in favor of a meaning that permits
            Covered Entity to comply with the HIPAA Rules.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              6.3(b)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Any inconsistency between the BAA's provisions and the HIPAA Rules,
            including all amendments, as interpreted by the HHS, a court, or
            another regulatory agency with authority over the Parties, shall be
            interpreted according to the interpretation of the HHS, the court,
            or the regulatory agency.
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "-0.5pt" }}
          >
            &nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0pt",
            marginLeft: "0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              6.3(c)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            .
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            &nbsp;{" "}
          </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            Any
          </span>
          <span style={{ verticalAlign: "top" }}> </span>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            provision of this BAA that differs from those required by the HIPAA
            Rules, but is nonetheless permitted by the HIPAA Rules, shall be
            adhered to as stated in this BAA.
          </span>
        </p>
        <p
          style={{
            margin: "0pt 5.15pt 12pt 0.1pt",
            textIndent: "-0.1pt",
            textAlign: "justify",
            lineHeight: "normal",
            widows: 0,
            orphans: 0,
            verticalAlign: "top",
          }}
        >
          <strong>
            <span
              style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
            >
              IN WITNESS WHEREOF,{" "}
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Times New Roman"', verticalAlign: "top" }}
          >
            the parties have executed this BAA as of the day and year first
            above written.
          </span>
        </p>

        <RXForm
          data={data}
          signImages={signImages}
          setSignImages={setSignImages}
          setSignType={(type) => setSignType(type)}
          handleOnSignatureClick={handleOnSignatureClick}
          filledSignatureIds={filledSignatureIds}
          setFilledSignatureIds={setFilledSignatureIds}
          handleOnSignatureChange={handleOnSignatureChange}
        />
      </div>
      <SignatureModal
        defaultName={
          isMD // signType === "adminPracticeSign"
            ? mdFormData?.md_name
            : mdFormData?.admin_name || ""
        }
        signatureType={signType}
        // onSubmit={(signedDoc, type) => onSignauteSubmit(signedDoc, type)}
        onClose={onClose}
        open={open}
        onSubmit={(signedDoc, type) => {
          uploadSignatureFile(signedDoc, type, selectedFillId);
        }}
        isLoading={isSignatureUploadLoading}
      />
    </div>
  );
};

export default FullComponent;
